


















































































































import { mapGetters } from 'vuex';
import { TranslateResult } from 'vue-i18n';
import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { SearchPayload, CitationInfoPayload, AppealHearingPayload } from '@/Stores/AppealStore';
import { Hearing } from './Information/Hearing';
import HearingOfficerDropdown from '@/Shared/HearingOfficerDropdown.vue';
import HearingResultDropdown from '@/Shared/HearingResultDropdown.vue';
import { SearchParams } from './Citation/SearchParams';
import { CitationInfo } from './Information/CitationInfo';
import { formatDateTimeToString } from '@/Shared/Filters';

const msgBoxOptions = {
        centered: true,
        okVariant: 'danger',
        cancelDisabled: true,
        modalClass: 'deleteRowClass',
        hideBackdrop: true
    };
const saveMsgBoxOptions = {
    centered: true,
    okVariant: 'success',
    hideBackdrop: true
};
const HearingInfoApp: any = mixins(LocationBasedMixin).extend({
    components: {
        HearingOfficerDropdown,
        HearingResultDropdown
    },
    data() {
        return {
            i18nPrefix: 'appeals.hearingInfo'
        };
    },
    computed: {
        ...mapGetters('appealModule', [
            'searchError',
            'searchInProgress',
            'getHearingInfo',
            'getSearchResults',
            'hearingInfoLoaded',
            'appellantLoaded',
            'checkAppellantRequiredFields',
            'getHearingResultList'
        ]),
        hearing(): Hearing {
            const getHearing = this.getHearingInfo.hearing;
            getHearing.citationAmt = Number(this.getSearchResults.remainingBalance).toFixed(2);
            getHearing.originalCitationAmt = Number(this.getSearchResults.remainingBalance).toFixed(2);
            return getHearing || new Hearing();
        }
    },
    mounted() {
        if (!this.getSearchResults.citationNumber) {
            return;
        }

        const searchParams = new SearchParams();
        searchParams.citationNumber = this.getSearchResults.citationNumber;
        searchParams.vehicleState = this.getSearchResults.vehicleState;
        searchParams.vehicleLicense = this.getSearchResults.vehicleLicense;

        if (this.hearingInfoLoaded) {
            return;
        }

        const payload: SearchPayload = {
                parameters: searchParams,
                location: this.$typedStore.state.currentLocation
            };

        this.$typedStore.modules.appealModule.actions.loadHearingInfo(payload);

        if (!this.appellantLoaded) {
            this.$typedStore.modules.appealModule.actions.searchAppellant(payload);
        }
    },
    methods: {
        async indefiniteHold() {
            const nextYear = new Date().setFullYear(new Date().getFullYear() + 1);
            this.hearing.hearingDateStr = new Date(nextYear);
        },
        async cancelHearingFlag() {
            const message: TranslateResult = this.$t('appeals.hearingInfo.cancelWarning');
            if (!await this.$bvModal.msgBoxConfirm(message.toString(), msgBoxOptions)) {
                return;
            }

            const payload: AppealHearingPayload = {
                parameters: {
                    appeal: null,
                    vehicleLicense: this.getSearchResults.vehicleLicense,
                    vehicleState: this.getSearchResults.vehicleState,
                    hearing: this.getHearingInfo.hearing,
                    citationNumber: this.getSearchResults.citationNumber,
                    userID: this.$typedStore.modules.userModule.getters.userName,
                    action: 'CancelHearing',
                },
                location: this.$typedStore.state.currentLocation
            };

            await this.$typedStore.modules.appealModule.actions.updateHearing(payload);
        },
        async saveHearing() {
            if (this.checkAppellantRequiredFields) {
                await this.updateCitation();
                const hearingInfo = this.hearing || new Hearing();

                if (hearingInfo.citationRecId == null) {
                    hearingInfo.citationRecId = this.getSearchResults.citationNumber;
                }

                hearingInfo.hearingDate = formatDateTimeToString(this.getHearingInfo.hearing.hearingDateStr,
                this.getHearingInfo.hearing.hearingTimeStr);

                hearingInfo.hearingDecision = this.hearing.hearingDecision;
                hearingInfo.hearingNotifiedDate = this.hearing.notifiedDate;

                const payload: AppealHearingPayload = {
                    parameters: {
                        appeal: null,
                        vehicleLicense: this.getSearchResults.vehicleLicense,
                        vehicleState: this.getSearchResults.vehicleState,
                        action: 'EditHearing',
                        hearing: hearingInfo,
                        citationNumber: this.getSearchResults.citationNumber,
                        userID: this.$typedStore.modules.userModule.getters.userName
                    },
                    location: this.$typedStore.state.currentLocation
                };
                await this.$typedStore.modules.appealModule.actions.updateHearing(payload);
                const messageSaved: TranslateResult = this.$t('appeals.saveSuccessMessage');
                await this.$bvModal.msgBoxConfirm(messageSaved.toString(), saveMsgBoxOptions);

                return;
            }

            const message: TranslateResult = this.$t('appeals.information.appellant.appellantErrorMessage');

            if (await this.$bvModal.msgBoxConfirm(message.toString(), msgBoxOptions)) {
                this.$router.push({
                    name: 'information', params: { location: this.location }
                });
            } else {
                return;
            }
        },
        async updateCitation() {
            const citationInfo = new CitationInfo();
            let hearingfee = 0;
            let autovoid = null;
            let hearingdesc = '';

            let list: any[] = [];
            if (this.getHearingResultList.length) {
                list = this.getHearingResultList;
                list = list.filter(s => {
                    if (s.code === this.hearing.hearingDecision) {
                        return s;
                    }
                });
            }
            if (list.length) {
                if (list[0].hasOwnProperty('hearingFee')) {
                    hearingfee = list[0].hearingFee;
                }
                if (list[0].hasOwnProperty('autoVoid')) {
                    autovoid = list[0].autoVoid;
                }
                if (list[0].hasOwnProperty('description')) {
                    hearingdesc = list[0].description;
                }
            }

            if (this.getHearingInfo.hearing.originalHearingDecision !==
            this.getHearingInfo.hearing.hearingDecision) {
                if (Number(hearingfee) > 0) {
                    citationInfo.citationNumber = this.getSearchResults.citationNumber;
                    citationInfo.originalAmount = Number(this.hearing.originalCitationAmt);
                    citationInfo.newAmount = Number(this.hearing.originalCitationAmt) + Number(hearingfee);
                    citationInfo.source = 'Hearing';
                    citationInfo.historyReason = hearingfee.toFixed(2).toString() + ' HEARING FEE ADDED';
                    citationInfo.userName = this.$typedStore.modules.userModule.getters.userName;
                }

                if (autovoid != null) {
                    citationInfo.citationNumber = this.getSearchResults.citationNumber;
                    citationInfo.explanation = hearingdesc;
                    citationInfo.autoVoid = autovoid;
                    citationInfo.reason = 'Hearing Decision';
                    citationInfo.userName = this.$typedStore.modules.userModule.getters.userName;
                }
            }

            if (Number(this.hearing.citationAmt) > 0
                && Number(this.hearing.citationAmt) !== Number(this.hearing.originalCitationAmt)) {
                    citationInfo.citationNumber = this.getSearchResults.citationNumber;
                    citationInfo.originalAmount = Number(this.hearing.originalCitationAmt);
                    citationInfo.newAmount = Number(this.hearing.citationAmt);
                    citationInfo.source = 'Hearing';
                    citationInfo.historyReason = hearingdesc;
                    citationInfo.userName = this.$typedStore.modules.userModule.getters.userName;
            }

            if (citationInfo.citationNumber) {
                const payloadCitation: CitationInfoPayload = {
                    citationInfo,
                    location: this.$typedStore.state.currentLocation
                };

                await this.$typedStore.modules.appealModule.actions.updateCitation(payloadCitation);
                const messageSaved: TranslateResult = this.$t('appeals.saveSuccessMessage');
                await this.$bvModal.msgBoxConfirm(messageSaved.toString(), saveMsgBoxOptions);
                this.hearing.originalCitationAmt = Number(citationInfo.newAmount).toFixed(2);
                this.hearing.citationAmt = Number(citationInfo.newAmount).toFixed(2);
            }
        }
    }
});

export default HearingInfoApp;
